import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

import { useCmsHook } from "../helpers/cms/cmsHook";

function Confirmation() {
  const { cmsInstance } = useCmsHook();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="py-5 page-bg-container">
      <Container
        className="window-bg-container px-5 py-4"
        style={{ backgroundColor: "#ffffff" }}
      >
        {cmsInstance &&
          cmsInstance.showRichText(
            "cmsContent.confirmation",
            "confirmation-page"
          )}
      </Container>
    </div>
  );
}

export default Confirmation;
